import React from 'react';
import { styled } from 'linaria/react';
import { useStore } from 'effector-react';
import { Position, SideSheet } from 'evergreen-ui';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useLocation } from 'react-use';

import { routes } from 'src/routes';
import { Aside } from 'src/ui/organisms/aside';
import { GroupPage } from './features/group/group.page';
import { drawer, drawerState$ } from 'src/store/drawer.store';
import { ProfilePage } from './features/profile/profile.page';
import { OpenGroupsPage } from './features/open-groups/open-groups.page';
import { UserGroupsPage } from 'src/features/home/features/user-groups/user-groups.page';
import { CreateGroupPage } from 'src/features/home/features/create-group/create-group.page';
import { FavoriteGroupsPage } from 'src/features/home/features/favorite-groups/favorite-groups.page';

const HomeContainer = styled.div`
	display: grid; 
  grid-template-columns: 260px 1fr;
  grid-template-rows: 1fr;
  min-height: var(--view-height);
  margin: 0;
  
  @media (max-width: 890px) {
		grid-template-columns: 1fr;
	}
`;
const AsideContainer = styled.div`
	flex: 1;
	
	@media (max-width: 890px) {
		display: none;
	}
`;

export const HomePage = () => {
	const drawerState = useStore(drawerState$);
	const location = useLocation();

	const menu = [{
		title: 'Open boxes',
		href: routes.root.home.groups.path,
		exact: true,
	}, {
		title: 'My boxes',
		href: routes.root.home.userBoxes.path,
	}, {
		title: 'Favorite boxes',
		href: routes.root.home.favorite.path,
	}, {
		title: 'Profile',
		href: routes.root.home.profile.path,
	}].map(item => ({
		...item,
		active: item.exact
			? location.pathname === item.href
			: location.pathname?.startsWith(item.href) || false,
	}));

	return (
		<>
			<HomeContainer>
				<AsideContainer>
					<Aside
						menu={menu}
					/>
				</AsideContainer>
				<Switch>
					<Route path={routes.root.home.profile.path}>
						<ProfilePage/>
					</Route>
					<Route path={routes.root.home.groups.path} exact={true}>
						<OpenGroupsPage/>
					</Route>
					<Route path={routes.root.home.favorite.path}>
						<FavoriteGroupsPage/>
					</Route>
					<Route
						path={routes.root.home.userBoxes.path}
					>
						<UserGroupsPage/>
					</Route>
					<Route path={routes.root.home.group.path}>
						<GroupPage/>
					</Route>
					<Route path={routes.root.home.createGroup.path}>
						<CreateGroupPage/>
					</Route>
					<Redirect
						from={routes.root.home.path}
						to={routes.root.home.groups.path}
					/>
				</Switch>
			</HomeContainer>
			<SideSheet
				isShown={drawerState}
				onCloseComplete={() => drawer.close()}
				width={260}
				position={Position.LEFT}
			>
				<Aside
					menu={menu}
					onClick={drawer.close}
				/>
			</SideSheet>
		</>
	);
};
